import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { VaultLogo } from 'src/components/foundations/VaultLogo';
import { Footer } from 'src/components/moleculesLegacy/Footer/Footer';
import { useIsMobile } from 'src/hooks/useIsMobile';
import { LoginPageLayout } from '../../Common/LoginPageLayout';
import { HeaderTitle } from '../../Common/LoginPageLayout/components/LoginContainerHeader.styles';

interface Props {
  children: ReactNode;
}

export const LoginContainer = (props: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const title = t('reporting.ReportingLogin.title');

  return (
    <LoginPageLayout
      header={
        <>
          <VaultLogo
            size={isMobile ? 'default' : 'large'}
            color="N800"
            altText={t('public.CustomHeader.companyLogo', {
              company: 'Vault Platform',
            })}
          />
          {title && <HeaderTitle>{title}</HeaderTitle>}
        </>
      }
      footer={<Footer showVaultLogo={false} />}
    >
      {props.children}
    </LoginPageLayout>
  );
};
